<template>
  <div class="article-page">
    <section class="article-masthead">
      <div class="site-shell article-masthead__inner">
        <button type="button" class="back-link" @click="goBack"><i class="el-icon-arrow-left"></i> 返回资讯</button>
        <div class="story-meta">
          <span>{{ getCategoryName(newsDetail.category) }}</span>
          <time>{{ formatDate(newsDetail.publishTime) }}</time>
        </div>
        <h1>{{ newsDetail.title }}</h1>
        <div class="article-byline">
          <span>作者：{{ newsDetail.author || '中国玉雕大师收藏网编辑部' }}</span>
          <span>{{ newsDetail.viewCount || 0 }} 次阅读</span>
        </div>
      </div>
    </section>

    <article class="article-body">
      <div v-if="newsDetail.coverImage" class="article-cover">
        <img :src="getFullImageUrl(newsDetail.coverImage)" :alt="newsDetail.title">
      </div>
      <div class="rich-text article-content" v-html="newsDetail.content"></div>
      <div class="article-actions">
        <button type="button" class="jade-button jade-button--dark" @click="goBack"><i class="el-icon-arrow-left"></i> 返回列表</button>
        <button type="button" class="text-link" @click="scrollToTop">返回顶部 <i class="el-icon-top"></i></button>
      </div>
    </article>
  </div>
</template>

<script>
import { getNewsDetail } from '@/api/news'
import { getDictData } from '@/api/system/dict'

export default {
  name: 'NewsDetail',
  data() {
    return { newsDetail: {}, categories: {} }
  },
  created() {
    this.fetchCategories()
    this.fetchNewsDetail()
  },
  methods: {
    async fetchCategories() {
      try {
        const response = await getDictData({ dictType: 'industry_news_type', pageNum: 1, pageSize: 100 })
        if (response.code === 200) {
          const categoryMap = {}
          ;(response.rows || []).forEach(item => { categoryMap[item.dictValue] = item.dictLabel })
          this.categories = categoryMap
        }
      } catch (error) {
        console.error('获取分类数据出错:', error)
      }
    },
    async fetchNewsDetail() {
      const id = this.$route.params.id
      if (!id) {
        this.$router.push('/news')
        return
      }
      try {
        const response = await getNewsDetail(id)
        if (response.code === 200) {
          this.newsDetail = response.data || {}
          document.title = (this.newsDetail.title || '资讯详情') + ' - 中国玉雕大师收藏网'
        } else {
          this.$message.error(response.msg || '获取资讯详情失败')
          this.$router.push('/news')
        }
      } catch (error) {
        console.error('获取资讯详情出错:', error)
        this.$message.error('获取资讯详情失败')
        this.$router.push('/news')
      }
    },
    getFullImageUrl(path) {
      if (!path) return ''
      if (path.startsWith('http')) return path
      return path.startsWith('/profile/upload') ? process.env.VUE_APP_BASE_API + path : path
    },
    getCategoryName(category) {
      return this.categories[category] || '馆藏资讯'
    },
    formatDate(dateStr) {
      return dateStr ? new Date(dateStr).toLocaleDateString() : ''
    },
    goBack() {
      this.$router.push('/news')
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>
